/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import React from 'react';

import Sidebar from './sidebar';
import { MainContainerStyled } from './styles';

const SidebarWrapper = ({ children, pathPrefix = '' }) => (
  <MainContainerStyled className="main-container">
    <Sidebar pathPrefix={pathPrefix} />
    <div className="content">{children}</div>
  </MainContainerStyled>
);

export default SidebarWrapper;
